import { VBottomSheet } from 'vuetify/lib/components/VBottomSheet';
import { VOverlay } from 'vuetify/lib/components/VOverlay';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _setup.hasWindow
    ? _c(
        "div",
        [
          _c(VOverlay, {
            model: {
              value: _setup.isOpen,
              callback: function ($$v) {
                _setup.isOpen = $$v
              },
              expression: "isOpen",
            },
          }),
          _vm._v(" "),
          _c(
            VBottomSheet,
            {
              attrs: { fixed: "" },
              model: {
                value: _setup.isOpen,
                callback: function ($$v) {
                  _setup.isOpen = $$v
                },
                expression: "isOpen",
              },
            },
            [
              _c(_setup.LanguagesListComponent, {
                tag: "component",
                attrs: { languages: _vm.languages },
              }),
            ],
            1
          ),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }